// @flow

import { Field } from 'react-form';
import { Input } from 'semantic-ui-react';
import React from 'react';

type Props = {
  onChange: (v: string) => void,
  field: string,
  validate: Function
};

const CustomInput = (props: Props) => {
  const { onChange, field, validate, ...rest } = props;

  return (
    <Field validate={validate} field={field}>
      {fieldApi => {
        const { value, setValue } = fieldApi;

        return (
          <Input
            {...rest}
            value={value || ''}
            onChange={e => {
              setValue(e.target.value);

              if (onChange) {
                onChange(e.target.value);
              }
            }}
          />
        );
      }}
    </Field>
  );
};

export default CustomInput;



// WEBPACK FOOTER //
// ./src/forms/Input.js